import { render, staticRenderFns } from "./PersonMemoList.vue?vue&type=template&id=65ae0ab8&"
import script from "./PersonMemoList.vue?vue&type=script&lang=js&"
export * from "./PersonMemoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports